import React from 'react';
import Field from './../field/Field';
import RadioGroup from './../RadioGroup';
import { topics } from '../constants/constants';

export const mainFields = (handleValueChange, isStaging) => {
    return [
        <Field
            key="title"
            title="Title *"
            id="title"
            required="true"
            emoji={true}
            name="title"
            placeholder="Notitification title"
            error_msg="Should not be empty"
            root="payload"
            listener={handleValueChange}
        />,
        <Field
            key="text"
            title="Notification text *"
            id="text"
            required="true"
            emoji={true}
            name="text"
            placeholder="Notification text"
            error_msg="Should not be empty"
            root="payload"
            listener={handleValueChange}
        />,
        <Field
            key="thumbUrl"
            title="Notification thumbnail url"
            id="thumbnailUrl"
            name="thumbUrl"
            upload={true}
            isUrl="true"
            isStaging={isStaging}
            placeholder="thumbnail url with https prefix"
            error_msg="Should not be empty and start with https prefix"
            root="payload"
            listener={handleValueChange}
        />,
        <Field
            key="imageUrl"
            title="Notification large image url"
            id="imageUrl"
            name="imageUrl"
            upload={true}
            isStaging={isStaging}
            isUrl="true"
            placeholder="notification image url with https prefix"
            error_msg="Should not be empty and start with https prefix"
            root="payload"
            listener={handleValueChange}
        />
    ];
}

export const mainTopics = (handleValueChange, isStaging) => {
    return (
        <RadioGroup
            label="Devices' topic to send to"
            name="topic"
            error_msg="Please select some topic"
            required="true"
            listener={handleValueChange}
            options={generatedTopics(isStaging)}
        />
    );
}

const generatedTopics = (isStaging) => {
    let ret = [];
    let arr = topics(isStaging);
    for (var index in arr) {
        ret.push({
            option: arr[index],
            label: arr[index]
        });
    }
    return ret;
}

const replyField = (handleValueChange) => {
    return (<Field
        data_validate=""
        title="A MESSAGE TO THANK THE USER FOR REPLY"
        id="push-reply"
        name="replyMessage"
        placeholder="Thank you message"
        error_msg="Should not be empty"
        value="Thank you for your review"
        root="payload"
        listener={handleValueChange}
    />);
};

const otherUrlField = (handleValueChange) => {
    return (<Field
        data_validate=""
        title="Link"
        id="other-keyUrl"
        name="url"
        required="true"
        root="payload"
        placeholder="Please enter push notification link to open"
        error_msg="Should not be empty"
        listener={handleValueChange}
    />);
}

const urlRadioGroup = (handleValueChange) => {
    return (
        <RadioGroup
            label="Push Notification Link to Open"
            name="url"
            id="push-browse"
            required="true"
            root="payload"
            default="https://news.google.com/?hl=en-IN&gl=IN&ceid=IN:en"
            listener={handleValueChange}
            options={[
                { option: 'https://news.google.com/?hl=en-IN&gl=IN&ceid=IN:en', label: 'https://news.google.com/?hl=en-IN&gl=IN&ceid=IN:en' },
                { option: 'null', label: 'Other', children: otherUrlField(handleValueChange) }
            ]}
        />
    );
};

export const notificationType = (handleValueChange, selectedTopic, isStaging) => {
    let options = [
        { option: 'link', label: 'Browser (to send push notification with link to open)', children: urlRadioGroup(handleValueChange) }
    ];
    if (selectedTopic && selectedTopic.value === topics(isStaging)[0]) {
        //enable reply option only for android topic type.
        options.push({ option: 'reply', label: 'Reply (to send push notification with reply option)', children: replyField(handleValueChange) });
    }
    return (
        <RadioGroup
            label="Push notifications type"
            name="type"
            required="true"
            default="link"
            error_msg="Please select a category"
            root="payload"
            listener={handleValueChange}
            options={options}
        />
    );
}